import React from 'react';
import { Button, Form, Segment, Input, Divider } from 'semantic-ui-react';
import axios from 'axios';
import { DateTimePicker } from 'react-widgets';
import 'react-widgets/dist/css/react-widgets.css';
import 'react-datepicker/dist/react-datepicker.css';

axios.defaults.xsrfHeaderName = "X-XSRF-TOKEN";
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
//axios.defaults.crossDomain = true;


export default class LeaseFilter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            organizationalUnitId: null,
            leaseholder: null,
            organizationalUnitProperty: null,
            dateStart: null,
            dateEnd: null,
            incomePerMonth: null,
            isInsideUniversity: null,
            comment: null,
            purpose: null,
            documentType: null,
            documentDate: null,
            documentNumber: null,
            documentComment: null,
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.onFilterData = this.onFilterData.bind(this);
    }

    onFilterData() {
        const leaseFilterData = {
            organizationalUnit: this.state.organizationalUnitId,
            leaseholder: this.state.leaseholder,
            organizationalUnitProperty: this.state.organizationalUnitProperty,
            dateStart: this.state.dateStart,
            dateEnd: this.state.dateEnd,
            incomePerMonth: this.state.incomePerMonth,
            purpose: this.state.purpose,
            comment: this.state.comment,
            organizationalUnitPropertyLeaseholder: null,
            legalDocumentType: this.state.documentType,
            date: this.state.documentDate,
            documentNumber: this.state.documentNumber,
        };

        this.props.onFilterData(leaseFilterData);
    }


    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    handleDateChange(name, date) {
        this.setState({
            [name]: date
        });
    }


    render() {
        return (
            <Segment raised>
                <Form>
                    {this.props.organizationalUnitsPrivilege &&
                    <Form.Group widths="4">
                        <Form.Dropdown clearable
                            label="Organizaciona jedinica"
                            placeholder="Organizaciona jedinica"
                            value={this.state.organizationalUnitId}
                            onChange={this.handleInputChange}
                            name="organizationalUnitId"
                            options={this.props.organizationalUnits}
                            search
                            fluid
                            selection
                        />
                    </Form.Group>
                    }
                    <Form.Group widths="4">
                        <Form.Dropdown clearable
                            label="Zakupac"
                            value={this.state.leaseholder}
                            options={this.props.leaseholders}
                            name="leaseholder"
                            placeholder="Izaberite zakupca"
                            onChange={this.handleInputChange}
                            search
                            fluid
                            selection
                        />

                        <Form.Dropdown clearable
                            label="Imovina"
                            value={this.state.organizationalUnitProperty}
                            options={this.props.properties}
                            name="organizationalUnitProperty"
                            placeholder="Izaberite imovinu"
                            onChange={this.handleInputChange}
                            search
                            fluid
                            selection
                        />

                        <Form.Field
                            label="Namjena"
                            control={Input}
                            name="purpose"
                            value={this.state.purpose}
                            onChange={this.handleInputChange}
                            placeholder="Unesite namjenu zakupa"
                        />

                        <Form.Field
                            label="Napomena"
                            control={Input}
                            name="comment"
                            value={this.state.comment}
                            onChange={this.handleInputChange}
                            placeholder="Unesite napomenu"
                        />
                    </Form.Group>
                    <Form.Group widths="4">
                        <Form.Field
                            control={DateTimePicker}
                            label="Datum početka"
                            format="DD.MM.YYYY."
                            time={false}
                            onChange={(e) => { this.setState({ dateStart: e }); console.log(this.state.dateStart); }}
                            value={this.state.dateStart}
                            style={{ borderWidth: '0px' }}
                        />

                        <Form.Field
                            control={DateTimePicker}
                            label="Datum kraja"
                            format="DD.MM.YYYY."
                            time={false}
                            onChange={(e) => { this.setState({ dateEnd: e }); console.log(this.state.dateStart); }}
                            value={this.state.dateEnd}
                            style={{ borderWidth: '0px' }}
                        />
                        <Form.Field
                            label="Mjesečni prihodi (BAM)"
                            type="number"
                            control={Input}
                            name="incomePerMonth"
                            value={this.state.incomePerMonth}
                            onChange={this.handleInputChange}
                            placeholder="Unesite mjesečna primanja"
                        />
                    </Form.Group>
                    <Divider />
                    <Form.Group widths="4">
                        <Form.Dropdown clearable
                            label="Tip dokumenta"
                            value={this.state.documentType}
                            options={this.props.legalDocumentTypes}
                            name="documentType"
                            placeholder="Izaberite tip dokumenta"
                            onChange={this.handleInputChange}
                            search
                            fluid
                            selection
                        />

                        <Form.Field
                            control={DateTimePicker}
                            label="Datum izdavanje dokumenta"
                            format="DD.MM.YYYY."
                            parse={str => { let parts = str.split('.'); return new Date(parts[2], parts[1] - 1, parts[0]); }}
                            time={false}
                            onChange={(e) => { this.setState({ documentDate: e }); }}
                            value={this.state.documentDate}
                            style={{ borderWidth: '0px' }}
                        />

                        <Form.Field
                            label="Broj dokumenta"
                            control={Input}
                            name="documentNumber"
                            value={this.state.documentNumber}
                            onChange={this.handleInputChange}
                            placeholder="Unesite broj dokumenta"
                        />
                    </Form.Group>
                    <Button
                        color="blue"
                        onClick={() => this.onFilterData()}
                    >
                    Filtriraj
                    </Button>
                    <Button
                        basic
                        color="blue"
                        onClick={this.props.cancelFilter}
                    >
                        Odustani
                    </Button>
                </Form>
            </Segment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Assets/Leases/LeasesFilter.js